<template>
  <div class="discover-block">
    <div class="container">
      <h3>Discover TRUE</h3>
      <h2>Where Innovation Meets Adventure</h2>
      <p>TRUE is more than just a game provider. It is a universe where&nbsp;stories come to life, where every game is a gateway to something greater.</p>
      <div class="cards">
        <div class="card">
          <div class="image">
            <img src="./images/discover-icon-01.svg">
          </div>
          <div class="content">
            <strong>Every Game is&nbsp;a&nbsp;Story</strong>
            <p>Our games are not just slots; they are immersive narratives that pull you into rich, evolving worlds.</p>
          </div>
        </div>
        <div class="card">
          <div class="image">
            <img src="./images/discover-icon-02.svg">
          </div>
          <div class="content">
            <strong>Web3 Empowerment</strong>
            <p>Blockchain technology ensures transparency, trust, and real ownership of in-game assets.</p>
          </div>
        </div>
        <div class="card">
          <div class="image">
            <img src="./images/discover-icon-03.svg">
          </div>
          <div class="content">
            <strong>A Living Ecosystem</strong>
            <p>Every game is part of a bigger adventure, connected through lore, rewards, and shared experiences.</p>
          </div>
        </div>
      </div>
      <div class="explore">
        <strong>Explore:</strong>
        <div class="buttons">
          <router-link :to="{ name: 'vision' }">TRUE Vision</router-link>
          <router-link :to="{ name: 'saga' }">TRUE Saga</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header-block',
}
</script>

<style lang="less" scoped>
  .discover-block {
    padding-top: 140px;
    padding-bottom: 180px;

    > .container {
      > h3 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 45px;
        text-align: center;
        margin-bottom: 2px;
        background: linear-gradient(90.62deg, #DF60FF 0%, #9C94FF 49.03%, #44E9C3 62.94%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      > h2 {
        color: #FFF;
        font-family: Poppins;
        font-weight: 700;
        font-size: 50px;
        line-height: 64px;
        text-align: center;
        margin-bottom: 16px;
      }
      > p {
        color: #FFFFFF99;
        font-family: Poppins;
        font-weight: 500;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 50px;
      }
      > .cards {
        display: flex;
        gap: 20px;
        margin-bottom: 40px;
        > .card {
          width: 380px;
          background: #C9D8FF0F;
          border-radius: 40px;
          padding: 36px 40px 36px 40px;
          > .image {
            margin-bottom: 24px;
            > img {
              display: block;
            }
          }
          > .content {
            > strong {
              display: block;
              color: #FFF;
              font-family: Poppins;
              font-weight: 700;
              font-size: 20px;
              line-height: 28px;
              margin-bottom: 6px;
            }
            > p {
              color: #FFFFFF99;
              font-family: Poppins;
              font-weight: 500;
              font-size: 18px;
              line-height: 28px;
            }
          }
        }
      }
      > .explore {
        > strong {
          display: block;
          color: #FFFFFF99;
          font-family: Poppins;
          font-weight: 500;
          font-size: 20px;
          line-height: 100%;
          text-align: center;
          margin-bottom: 15px;
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 190px;
            height: 60px;
            border-radius: 14px;
            transition: all .2s;
            color: #fff;
            font-size: 16px;
            line-height: 24px;
            border: 1px solid hsla(0, 0%, 100%, .2);
            &:hover {
              border-color: #fff;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1439px) {
    .discover-block {
      padding-top: 80px;
      padding-bottom: 94px;

      > .container {
        > h3 {
          font-size: 24px;
          line-height: 24px;
          margin-bottom: 0;
        }
        > h2 {
          font-weight: 700;
          font-size: 36px;
          line-height: 50px;
          margin-bottom: 12px;
        }
        > p {
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 40px;
        }
        > .cards {
          display: flex;
          gap: 12px;
          margin-bottom: 30px;
          > .card {
            width: 274px;
            border-radius: 30px;
            padding: 26px 30px 26px 30px;
            > .image {
              margin-bottom: 24px;
              > img {
                width: 117px;
              }
            }
            > .content {
              > strong {
                display: block;
                color: #FFF;
                font-family: Poppins;
                font-weight: 700;
                font-size: 18px;
                line-height: 26px;
                margin-bottom: 6px;
              }
              > p {
                color: #FFFFFF99;
                font-family: Poppins;
                font-weight: 500;
                font-size: 16px;
                line-height: 26px;
              }
            }
          }
        }
        > .explore {
          > strong {
            font-size: 16px;
            line-height: 100%;
            margin-bottom: 16px;
          }
          > .buttons {
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
            > a {
              width: 200px;
              height: 50px;
              border-radius: 14px;
              font-size: 12px;
              line-height: 22px;
              &:hover {
                border-color: #fff;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .discover-block {
      padding-top: 80px;
      padding-bottom: 100px;

      > .container {
        > h3 {
          font-size: 20px;
          line-height: 20px;
          margin-bottom: 0;
        }
        > h2 {
          font-weight: 700;
          font-size: 30px;
          line-height: 40px;
          margin-bottom: 10px;
        }
        > p {
          font-weight: 500;
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 30px;
        }
        > .cards {
          display: flex;
          gap: 16px;
          margin-bottom: 30px;
          > .card {
            width: 212px;
            border-radius: 20px;
            padding: 16px 20px 16px 20px;
            > .image {
              margin-bottom: 14px;
              > img {
                width: 100px;
              }
            }
            > .content {
              > strong {
                display: block;
                color: #FFF;
                font-family: Poppins;
                font-weight: 700;
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 6px;
                padding-right: 5px;
              }
              > p {
                color: #FFFFFF99;
                font-family: Poppins;
                font-weight: 500;
                font-size: 14px;
                line-height: 24px;
              }
            }
          }
        }
        > .explore {
          > strong {
            font-size: 14px;
            line-height: 100%;
            margin-bottom: 12px;
          }
          > .buttons {
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
            > a {
              width: 200px;
              height: 50px;
              border-radius: 14px;
              font-size: 12px;
              line-height: 22px;
              &:hover {
                border-color: #fff;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .discover-block {
      padding-top: 60px;
      padding-bottom: 60px;

      > .container {
        > h3 {
          font-size: 14px;
          line-height: 14px;
          margin-bottom: 0;
        }
        > h2 {
          font-weight: 700;
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 6px;
        }
        > p {
          font-weight: 500;
          font-size: 13px;
          line-height: 22px;
          margin-bottom: 20px;
        }
        > .cards {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 20px;
          > .card {
            width: 100%;
            border-radius: 20px;
            padding: 12px 15px 12px 15px;
            > .image {
              margin-bottom: 10px;
              > img {
                width: 74px;
              }
            }
            > .content {
              > strong {
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 2px;
                padding-right: 0;
              }
              > p {
                font-size: 12px;
                line-height: 20px;
              }
            }
          }
        }
        > .explore {
          > strong {
            font-size: 13px;
            line-height: 100%;
            margin-bottom: 10px;
          }
          > .buttons {
            display: flex;
            gap: 10px;
            justify-content: center;
            align-items: center;
            > a {
              width: 50%;
              height: 50px;
              border-radius: 12px;
              font-size: 14px;
              line-height: 22px;
              &:hover {
                border-color: #fff;
              }
            }
          }
        }
      }
    }
  }
</style>
